import styled from 'styled-components';

export const ExpertExpertiseContainer = styled.div`
  width: 100%;
  padding: 10px;
  background-color: white;
`;
